import { observable } from "mobx";

export class StakeViewModel {
    @observable stakeValue: number;
    @observable currencySign: string;
    eventId: string;
    @observable isMinusDisabled: boolean;
    @observable isPlusDisabled: boolean;
    @observable index: number;
    constructor(source: StakeViewModel) {
        this.stakeValue = source.stakeValue;
        this.currencySign = source.currencySign;
        this.eventId = source.eventId;
        this.isMinusDisabled = source.isMinusDisabled;
        this.isPlusDisabled = source.isPlusDisabled;
        this.index = source.index;
    }
}